import { SHOPIFY_STORE_DOMAIN, SHOPIFY_STOREFRONT_API_TOKEN } from '@portal/config/base';
import { StoreCode } from 'schema/storeCode';
import { cartAttributesUpdateMutation } from '../mutations/cartAttributesUpdate';
import { CartAttributesInput, CartDetails } from '../types';
import { formatCartLines, shopifyFetch } from '../utils';

async function cartAttributesUpdate({
  domain,
  token,
  cartInput
}: {
  cartInput: CartAttributesInput;
  domain: string;
  token: string;
}): Promise<CartDetails> {
  const res = await shopifyFetch<any>({
    query: cartAttributesUpdateMutation,
    shopifyDomain: domain,
    accessToken: token,
    variables: {
      cartId: cartInput.cartId,
      attributes: cartInput.attributes
    }
  });
  const rawCartData = res.body.data.cartAttributesUpdate.cart;

  return {
    ...rawCartData,
    lines: formatCartLines(rawCartData)
  };
}

export const updateShopifyCartAttributes = async (
  storeCode: StoreCode,
  cartInput: CartAttributesInput
): Promise<CartDetails> => {
  const cart = await cartAttributesUpdate({
    domain: SHOPIFY_STORE_DOMAIN[storeCode],
    token: SHOPIFY_STOREFRONT_API_TOKEN[storeCode],
    cartInput
  });

  return cart;
};
